import {
  IconicChart,
  IconicCreditCard,
  IconicDocumentShield,
  IconicFile2,
  IconicLocation,
  IconicUser,
} from '@insify/design-system/iconic-icons';
import { TrackedDiv } from '@objectiv/tracker-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { usePolicies } from '../../../api/queries/usePolicies';
import { useProfile } from '../../../api/queries/useProfile';
import { ProductAddressTab } from '../../../components/ProductDetail/Tabs/Address.tab';
import { ProductOverviewTab } from '../../../components/ProductDetail/Tabs/Overview.tab';
import { PaymentsTab } from '../../../components/ProductDetail/Tabs/Payments.tab';
import { ProductPersonalDetailsTab } from '../../../components/ProductDetail/Tabs/PersonalDetails.tab';
import { PolicyTab } from '../../../components/ProductDetail/Tabs/Policy.tab';
import { Tabs } from '../../../components/Tabs';
import { InvoicesPage } from '../InvoicesPage';

import styles from './styles.module.css';

const ProductDetailPage: React.FC = () => {
  const { t } = useTranslation('navigation');
  const { id } = useParams<{ id: string }>();

  const { data: policies } = usePolicies();
  const bundle = policies?.find((policy) => policy.id === id);

  const { data: profileData } = useProfile();
  const profile = profileData?.result;

  const bankAccounts = profile?.personalInformation?.bankAccounts || [];

  if (!bundle) {
    return null; // Show loading state when bundle is not found yet
  }

  return (
    <TrackedDiv objectiv={{ id: `${bundle.type}-product` }} className={styles.productDetailPage}>
      <Tabs.Container defaultTab='overview'>
        <Tabs.List>
          <Tabs.Tab id='overview' label={t('overview')} icon={<IconicChart />} />
          {bundle.type === 'personal' && <Tabs.Tab id='invoices' label={t('invoices')} icon={<IconicFile2 />} />}
          <Tabs.Tab id='policy' label={t('policy')} icon={<IconicDocumentShield />} />
          <Tabs.Tab id='personal-details' label={t('personal_details')} icon={<IconicUser />} />
          {bankAccounts.length > 0 && <Tabs.Tab id='payments' label={t('payments')} icon={<IconicCreditCard />} />}
          <Tabs.Tab id='address' label={t('address')} icon={<IconicLocation />} />
        </Tabs.List>

        <ProductOverviewTab bundle={bundle} />

        <Tabs.Panel id='invoices'>
          <h2>Invoices</h2>
          <InvoicesPage />
        </Tabs.Panel>

        <Tabs.Panel id='policy'>
          {bundle.type === 'company' ? <PolicyTab.Company bundle={bundle} /> : <PolicyTab.Personal bundle={bundle} />}
        </Tabs.Panel>

        <ProductPersonalDetailsTab bundle={bundle} />
        {profile && <PaymentsTab overview={profile} bundle={bundle} />}

        <ProductAddressTab bundle={bundle} />
      </Tabs.Container>
    </TrackedDiv>
  );
};

export { ProductDetailPage };
